import { SoledadUtils } from './../../lib/helpers/utils';

export interface Note {
    agente1: number;
    agente2: number;
    almacen: number;
    bruto: number;
    bultos: number;
    cargoAbono: string;
    direccionEnvio: number;
    entregaCuenta: number;
    fecha: Date;
    formaEnvio: string;
    formaPago: number;
    neto: number;
    numero: string;
    observaciones1: string;
    observaciones2: string;
    observaciones3: string;
    pedido: string;
    periodicidad: number;
    referencia: string;
    responsableCobro: number;
    serie: string;
    tipoPortes: string;
    URL_PDF: string;////
}

export class NoteHelper {

    static create(): Note {
        return {
            agente1: 0,
            agente2: 0,
            almacen: 0,
            bruto: 0,
            bultos: 0,
            cargoAbono: '',
            direccionEnvio: 0,
            entregaCuenta: 0,
            fecha : null,
            formaEnvio: '',
            formaPago: 0,
            neto: 0,
            numero: '',
            observaciones1: '',
            observaciones2: '',
            observaciones3: '',
            pedido: '',
            periodicidad: 0,
            referencia: '',
            responsableCobro: 0,
            serie: '',
            tipoPortes: '',
            URL_PDF: ''
        };
    }

    static transformFromApi(apiData: Object) {

        const obj = NoteHelper.create();
        obj.agente1 = apiData['AL_AGENTE1'];
        obj.agente2 = apiData['AL_AGENTE2'];
        obj.almacen = apiData['AL_ALMACEN'];
        obj.bruto = apiData['AL_BRUTO'];
        obj.bultos = apiData['AL_BULTOS'];
        obj.cargoAbono = apiData['AL_CARGOABONO'];
        obj.direccionEnvio = apiData['AL_DIRECCIONENVIO'];
        obj.entregaCuenta = apiData['AL_ENTREGACUENTA'];
        obj.fecha = SoledadUtils.dateTimeParse(apiData['AL_FECHA']);
        obj.formaEnvio = apiData['AL_FORMAENVIO'];
        obj.formaPago = apiData['AL_FORMAPAGO'];
        obj.neto = apiData['AL_NETO'];
        obj.numero = apiData['AL_NUMERO'];
        obj.observaciones1 = apiData['AL_OBSERVACIONES1'];
        obj.observaciones2 = apiData['AL_OBSERVACIONES2'];
        obj.observaciones3 = apiData['AL_OBSERVACIONES3'];
        obj.pedido = apiData['AL_PEDIDO'];
        obj.periodicidad = apiData['AL_PERIODICIDAD'];
        obj.referencia = apiData['AL_REFERENCIA'];
        obj.responsableCobro = apiData['AL_RESPONSABLECOBRO'];
        obj.serie = apiData['AL_SERIE'];
        obj.tipoPortes = apiData['AL_TIPOPORTES'];
        return obj;
    }
}
